<template>
  <div id="attendance-img-wrapper">
    <div class="attendance-wrapper">
      <div v-for="i in 7" class="attendance_wrap" :class="{ seven: i === 7 }" :key="i">
        <div v-if="i === 7" class="title">7day</div>
        <img :src="attendanceImgUrl(i)" />
      </div>
    </div>

    <div class="apt-img" v-if="isMobile"></div>
  </div>
</template>

<script>
const isCoupons = (num) => (num === 7 ? 'my_coupons' : 'coupon');

export default {
  name: 'AttendanceBoard',
  props: {
    cnt_attendance: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  methods: {
    attendanceImgUrl(day) {
      const baseImgText = `${this.$s3}/img/common/mypage/`;
      const isAttendance = day <= this.cnt_attendance;
      const attendaneImgUrl = isAttendance ? `_active${this.atdcImgNum(day)}` : '';
      /** ${$s3}/img/common/mypage/<<my_coupons | coupon >><<_active (2 | 3)>>.svg?${$ver} */
      const imgUrl = `${baseImgText}${isCoupons(day)}${attendaneImgUrl}.svg?${this.$ver}`;
      return imgUrl;
    },
    atdcImgNum(num) {
      switch (num) {
        case 2:
        case 5:
          return '1';
        case 3:
        case 6:
          return '2';

        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#attendance-img-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  background: #ffffff;
  width: 100%;
  max-width: 419px;
  margin: 0 auto;
  aspect-ratio: 42 / 16.8;

  @media screen and (max-width: 1119px) {
    grid-template-columns: 1fr auto;
  }

  .apt-img {
    min-width: 72px;
    width: 100%;
    // aspect-ratio: 15.6 / 28.8;
    background: top / cover no-repeat url($s3-url + '/img/common/mypage/attendance.webp?' + $version);
  }

  .attendance-wrapper {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 1fr);
    border: 0.5px solid #ededed;
    border-left: 0;

    .attendance_wrap {
      position: relative;
      display: grid;
      place-items: center;
      border: 0.5px solid #ededed;
      padding: 6px;
      &.seven {
        grid-column: span 2 / span 3;
      }

      .title {
        font-size: 10px;
        color: #fff;
        background: #000000;
        border-radius: 10px;
        position: absolute;
        padding: 1px 6px;
        top: 0;
        right: 0;
      }
    }
  }
}
</style>
